import './RecommendAFreelancer.scss';

import React from 'react';
import { connect } from "react-redux";
import { routerActions } from "react-router-redux";
import update from "immutability-helper";

import { clearInvitationData, postRecommendation, setInvitationData } from 'containers/Auth/store/actions';

import Button from 'components/Button';
import H1 from 'components/H1';
import Modal from 'components/Modal';
import PageContent from 'components/PageContent';
import RequestInvitationForm from 'containers/Auth/RequestInvitationPage/RequestInvitationForm';

class RequestInvitationPage extends React.Component {
    constructor() {
        super();

        this.state = {
            showSuccessModal: false
        };
    }
    componentDidMount() {
        document.body.classList.add('recommend-a-freelancer-page');
    }

    componentWillUnmount() {
        document.body.classList.remove('recommend-a-freelancer-page');
    }

    handleChange(name, value) {
        let newInvitationDataObj = update(this.props.auth.invitationData, {});
        newInvitationDataObj[name] = value;
        this.props.setInvitationData(newInvitationDataObj);
    }

    handleSubmit() {
        return new Promise((resolve) => {
            this.props.postRecommendation()
                .then((res) => {
                    if(res === '') {
                        this.props.clearInvitationData();
                        this.setState({showSuccessModal: true});
                        resolve(res);
                    }
                });
        });
    }

    render() {
        return (
            <PageContent className="recommend-a-freelancer">
                <H1>
                    Recommend a Freelancer
                </H1>

                <div className="recommend-a-freelancer-form--wrapper">
                    <RequestInvitationForm
                        error={this.props.auth.error}
                        handleChange={this.handleChange.bind(this)}
                        handleSubmit={this.handleSubmit.bind(this)}
                        isFetching={this.props.auth.isRequestingInvitation}
                        isRecommendation={true}
                        invitationData={this.props.auth.invitationData}
                    />
                </div>

                <Modal show={this.state.showSuccessModal === true}
                       title="Success!">
                    <p>
                        We've received your recommendation. We'll review it and respond quickly.
                    </p>
                    <p>
                        Thank you for helping build the Hunt community!
                    </p>
                    <div className="c-modal__button-wrapper">
                        <Button onClick={() => this.setState({showSuccessModal: false})}>
                            OK
                        </Button>
                    </div>
                </Modal>
            </PageContent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (path) => dispatch(routerActions.push(path)),
        clearInvitationData: () => dispatch(clearInvitationData()),
        postRecommendation: () => dispatch(postRecommendation()),
        setInvitationData: (invitationDataObj) => dispatch(setInvitationData(invitationDataObj))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestInvitationPage);



// WEBPACK FOOTER //
// ./src/containers/Freelancers/RecommendAFreelancer/index.js